var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJpg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 700 700",
    style: {
      enableBackground: "new 0 0 700 700"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M213.4,455.3c4.4,0.5,8.9-0.4,12.8-2.6c3.9-2.2,7-5.5,8.8-9.6c1.8-5.4,2.6-11,2.3-16.7V384h-14.8v41c0.2,2.9,0.2,5.8,0,8.8 c-0.6,4.2-4.5,7.2-8.8,6.6c-2.7,0.2-5.4-0.9-7.2-3c-1.3-2.6-1.8-5.5-1.5-8.3h-14.9v2.1c-0.1,3.5,0.3,7,1.2,10.3 c1.5,4.5,4.5,8.3,8.5,10.8C203.9,454.9,208.7,455.9,213.4,455.3L213.4,455.3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M266.2,427.2h10.7c3.5,0.1,6.9-0.6,10.1-2c3.6-1.6,6.7-4.3,8.8-7.7c2.1-3.5,3.1-7.6,3.1-11.6c0.2-6.4-2.5-12.6-7.4-16.8 c-4.7-3.7-10.6-5.5-16.6-5.1h-23.3v70h14.8L266.2,427.2z M266.2,397.3h8.2c6.4,0,9.6,2.7,9.6,8.1c0.1,2.5-0.8,4.9-2.5,6.6 c-2,1.7-4.5,2.6-7.1,2.4h-8.2V397.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M337.5,455.3c7.4-0.2,14.5-2.9,20-7.8v6.6h13.2v-39H340v13.3h17.5v0c-0.6,3.6-2.7,6.8-5.9,8.8c-3.6,2.3-7.8,3.5-12,3.3 c-5.6,0.2-10.9-2-14.8-6c-3.8-4.2-5.8-9.7-5.5-15.4c-0.2-5.6,1.8-11.1,5.6-15.3c3.6-4,8.7-6.3,14.1-6.1c6.9-1,13.5,3.2,15.3,10h16.6 c-0.9-7-4.6-13.3-10.1-17.5c-6-4.7-13.5-7.2-21.2-7c-9.5-0.2-18.6,3.6-25.1,10.6c-6.7,7.1-10.4,16.5-10.1,26.2 c-0.3,9.4,3.1,18.5,9.5,25.4C320,451.9,328.6,455.5,337.5,455.3L337.5,455.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M553.2,214.9v-0.8c-0.4-0.9-1-1.7-1.7-2.4L429,89.2c-0.7-0.7-1.5-1.2-2.5-1.7h-0.9c-0.8-0.5-1.7-0.8-2.6-1H177.6 c-4.8,0-8.8,3.9-8.8,8.8v236.3h-26.2c-4.8,0-8.8,3.9-8.8,8.8v157.5c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h26.2v61.2 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h367.5c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2v-350v-0.5 C553.7,216.4,553.5,215.6,553.2,214.9L553.2,214.9z M431.3,116.4L524,209h-92.7V116.4z M151.3,349h262.5v140H151.3V349z M186.3,559 v-52.5h236.2c2.3,0,4.5-0.9,6.2-2.6s2.6-3.9,2.6-6.2V340.3c0-2.3-0.9-4.5-2.6-6.2s-3.9-2.6-6.2-2.6H186.3V104h227.5v113.8 c0,2.3,0.9,4.5,2.6,6.2s3.9,2.6,6.2,2.6h113.8V559H186.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJpg);
export default __webpack_public_path__ + "static/media/jpg.fbccf10e14e4810f42203e1d13ed1d50.svg";
export { ForwardRef as ReactComponent };